import { Moment } from "moment";
import { mutatorAction } from "satcheljs";
import { ShiftStoreSchema } from "sh-shift-store";

export default mutatorAction('SET_SHIFTS_CACHE_END_TIME_IN_STORE', function setShiftsCacheEndTimeInStore(shiftsCacheEndTime: Moment, shiftStoreEntity: ShiftStoreSchema) {
    shiftStoreEntity.shiftsCacheEndTime = shiftsCacheEndTime;
});
